export interface User {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly keycloakId: string;
  readonly group: string;
  readonly active: boolean;
  readonly department?: string;
}

export interface GetUsersFilters {
  readonly page: number;
  readonly size: number;
  readonly search?: string;
  readonly role?: string;
  readonly status?: string;
  readonly department?: string;
}

export class GetUsersFilters {
  public static initial(): GetUsersFilters {
    return {
      page: 0,
      size: 15,
    };
  }
}
